module.exports = __webpack_public_path__ + "media/images/version_merge/qr_code/modal/rule3-64818d9b918405b3fe26a5593635fcf2.png";